module.exports = __webpack_public_path__ + "img/5.04.dd15bebb.jpg";